/*
* Broadcast Theme
*
* Use this file to add custom Javascript to Broadcast.  Keeping your custom
* Javascript in this fill will make it easier to update Broadcast. In order
* to use this file you will need to open layout/theme.liquid and uncomment
* the custom.js script import line near the bottom of the file.
*/


(function() {
  // Add custom code below this line

  /** 
   * Legacy readability mode migrated from previous theme
   * Can be toggled from /pages/accessibility
   */
  const a11yUrlParams = new URLSearchParams(window.location.search);
  const a11yUrlParam = a11yUrlParams.get('a11y');
  const a11ySelectors = 'p, h1, h2, h3, h4, h5, h6, a';
  
  function initReadabilityMode() {
      // If query string requests a toggle
      if (a11yUrlParam === 'toggle') {
          if (a11yReadCookie('a11y') === 'on') {
              a11yEraseCookie('a11y');
          } else {
              a11yCreateCookie('a11y', 'on', false);
              applyReadabilityMode();
          }
      }
  
      // If cookie enables readability mode
      if (a11yReadCookie('a11y') === 'on') {
          applyReadabilityMode();
      }
  }
  initReadabilityMode();
  
  function applyReadabilityMode() {
      document.querySelectorAll(a11ySelectors).forEach(element => {
          element.style.backgroundColor = 'white';
          element.style.color = 'black';
      });
  }  
  
  function a11yCreateCookie(name, value, days) {
      if (days) {
          var date = new Date();
          date.setTime(date.getTime() + (days*24*60*60*1000));
          var expires = '; expires=' + date.toGMTString();
      } else {
          var expires = '';
      }
      
      document.cookie = name + '=' + value + expires + '; path=/';
  }
  
  function a11yReadCookie(name) {
      var nameEQ = name + '=';
      var ca = document.cookie.split(';');
      
      for (var i = 0; i < ca.length; i++) {
          var c = ca[i];
          while (c.charAt(0) == ' ') {
              c = c.substring(1, c.length);
          }
          if (c.indexOf(nameEQ) == 0) {
              return c.substring(nameEQ.length, c.length);
          }
      }
      
      return null;
  }
  
  function a11yEraseCookie(name) {
      a11yCreateCookie(name, '', -1);
  }
    
  /** 
   * Toggle product page badges based on variant availability
   * Additional code in snippets/product.liquid
   */  
  const variantChangeEvent = theme.PUB_SUB_EVENTS.variantChange;
  subscribe(variantChangeEvent, (event) => {
      const variant = event.data.variant;
  
      if (!variant) {
          return;
      }
  
      if (variant.available) {
          document.querySelector('.product__badges:not(.product__badges__unavailable)').style.display = 'flex';
          document.querySelector('.product__badges__unavailable').style.display = 'none';
      } else {
          document.querySelector('.product__badges:not(.product__badges__unavailable)').style.display = 'none';
          document.querySelector('.product__badges__unavailable').style.display = 'flex';         
      }
  });  

  // ^^ Keep your scripts inside this IIFE function call to 
  // avoid leaking your variables into the global scope.
})();
